import { cx } from "cva";
import { type PropsWithChildren } from "react";

import { OpenInNewIcon } from "../Icon";
import { LinkExternalProps, variants } from ".";
import styles from "./index.module.css";

export const LinkExternal = ({
  title,
  target = "_blank",
  rel = "noopener noreferrer",
  appearance,
  widthType,
  align,
  fontSize,
  className,
  children,
  ...props
}: PropsWithChildren<LinkExternalProps>) => {
  const iconSize = fontSize === "xxs" ? "xs" : "s";

  return (
    <a
      title={title}
      target={target}
      rel={rel}
      className={cx(className, variants({ appearance, widthType, align, fontSize }))}
      {...props}
    >
      <span>
        {children}
        <span className="sr-only">(別ウィンドウで開きます)</span>
        <OpenInNewIcon className={styles.icon} size={iconSize} color="link" />
      </span>
    </a>
  );
};
